// Limpiezas que corren en cada `clearSession` (utils/tokenUtils.ts).
//
// Las pide quien guarda algo de la sesión fuera de tokenUtils (p. ej. el store
// de derechos de CC-CONSOLE, #649), registrándose desde su propio módulo. Así
// tokenUtils —idéntico en CC-CONSOLE y WAYAK— no importa stores que el otro
// fork no tiene. Sin dependencias a propósito: hay pruebas que sustituyen
// tokenUtils por un mock y aun así cargan esos stores.

const listeners = new Set<() => void>();

/**
 * Registra una limpieza que corre en cada `clearSession`. Devuelve la función
 * que la quita.
 */
export const onSessionCleared = (listener: () => void): (() => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/** Corre las limpiezas registradas; una que falla no frena a las demás. */
export const runSessionCleanups = (): void => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (error) {
      console.error("Error en una limpieza de clearSession:", error);
    }
  });
};
